export class ContactDepartmentFilter {
    public IncludeInactive?: boolean;
}

export default ContactDepartmentFilter;